import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { BackendListModel } from 'src/app/models/common/list.model';
import { UserList } from 'src/app/models/user-list';
import { ContactsModel } from 'src/app/pages/one-way-data/request/requirements-model';
import { AckRequestService } from 'src/app/services/ack-request.service';
import { ApiRoutes } from 'src/app/services/apiroutes';
import { WarningBoxComponent } from '../../dialog-box/warning-box/warning-box.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'logzy-contact-persons',
  templateUrl: './contact-persons.component.html',
  styleUrls: ['./contact-persons.component.scss']
})
export class ContactPersonsComponent implements OnInit {

  contacts = [];
  userList: BackendListModel<UserList>;
  base_url = ApiRoutes.Company;

  constructor(private dialog: MatDialog) { }

  ngOnInit(): void {
    this.contacts.push(new ContactsModel());
  }

  addContactDetails() {
    let row = this.contacts.length - 1;
    if (this.contacts[row].contact_name == '' || this.contacts[row].contact_email == '' || this.contacts[row].contact_number == '' || this.contacts[row].profile_role == '') {
      this.openWarningDialog('Please select user and enter contact details', '', 'Ok');
    } else {
      this.contacts.push(new ContactsModel());
    }
  }

  removeContact(idx) {
    this.contacts.splice(idx, 1);
  }

  fetchUserDetails(user, i) {
    console.log(user);
    if (user.id != 'custom') {
      this.contacts[i].contact_name = user.first_name ? (user.first_name + ' ' + user.last_name) : '';
      this.contacts[i].profile_role = user.profile_role ? user.profile_role : '';
      this.contacts[i].contact_email = user.email ? user.email : '';
      this.contacts[i].contact_number = user.phone ? user.phone.as_e164 : '';
    } else {
      this.contacts[i].contact_name = '';
      this.contacts[i].profile_role = '';
      this.contacts[i].contact_email = '';
      this.contacts[i].contact_number = '';
    }
  }

  resetContacts() {
    this.contacts = [];
    this.contacts.push(new ContactsModel());
  }

  openWarningDialog(label: string, description, action1: string, action2?: string, action3: string = null) {
    const dialogRef = this.dialog.open(WarningBoxComponent, {
      panelClass: 'dialog-container-custom',
      disableClose: true,
      data: { subTitle: label, parent: this, description: description, label1: action1, label2: action2, label3: action3 }
    });

    dialogRef.afterClosed().subscribe(item => {
      if (item) {

      }
    })
  }
}
